import { atom } from 'recoil'
import { IGrade } from 'screens/Protection/protection.types'
import { SelectOption } from 'shared/Inputs/Select'

interface IGradeTableAtomState {
  items: IGrade[]
  filters: {
    search?: string
    expertIds: SelectOption[]
    roomId?: string
    date?: Date | null
  }
}

const gradeTableAtom = atom<IGradeTableAtomState>({
  key: 'tables/admin/grade',
  default: { items: [], filters: { search: '', expertIds: [], roomId: '', date: null } },
})
export default gradeTableAtom
